import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useLang } from "../i18n/LanguageContext";
import { Reveal } from "./Reveal";
import { BRANDS, BRAND_LOGOS } from "../data/content";

export function BrandStrip() {
  const { lang } = useLang();
  return (
    <section className="border-y border-[#e4e9f0] bg-white py-16" data-testid="brand-strip">
      <div className="pn-container">
        <Reveal>
          <p className="text-center text-xs uppercase tracking-[0.22em] text-[#4a4d52]">{lang === "de" ? "Unsere Marken" : "Our brands"}</p>
        </Reveal>
        <div className="mt-10 grid grid-cols-2 items-center gap-x-8 gap-y-10 sm:grid-cols-3 lg:grid-cols-5">
          {BRANDS.map((b, i) => (
            <motion.div key={b.sku}
              initial={{ opacity: 0, y: 16 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: i * 0.08, duration: 0.5 }}
              className="flex justify-center">
              <Link to={b.href} aria-label={b[lang].name} className="group">
                <img src={BRAND_LOGOS[b.sku]} alt={`${b[lang].name} – ${b.material} Markenlogo`}
                  className="h-9 w-auto object-contain opacity-70 grayscale transition-all duration-300 group-hover:opacity-100 group-hover:grayscale-0 md:h-10"
                  loading="lazy" />
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
